import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_CASHIERS,
  CREATE_CASHIER,
  UPDATE_CASHIER,
  DELETE_CASHIER,
} from "./actionTypes"
import {
  getAllCashiersCall,
  createCashierCall,
  updateCashierCall,
  deleteCashierCall,
  API_URL,
} from "../../helpers/repository"
import { getAllCashiers, getAllCashiersResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllCashiers() {
  try {
    const response = yield call(getAllCashiersCall)
    yield put(getAllCashiersResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateCashier(action) {
  const { history } = action
  try {
    const response = yield call(createCashierCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/admin/cashiers")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditCashier(action) {
  const { history, id } = action
  try {
    const response = yield call(updateCashierCall, action.payload, id)
    showMessage("success", response.data.message)
    yield put(getAllCashiers())
    history.push("/admin/cashiers")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteCashier(action) {
  try {
    const response = yield call(deleteCashierCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllCashiers())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* CashiersSaga() {
  yield takeEvery(GET_ALL_CASHIERS, attemptGetAllCashiers)
  yield takeEvery(CREATE_CASHIER, attemptCreateCashier)
  yield takeEvery(UPDATE_CASHIER, attemptEditCashier)
  yield takeEvery(DELETE_CASHIER, attemptDeleteCashier)
}

export default CashiersSaga
